<template>
		<v-card>
			<v-card-text>
				<v-form ref="Form" v-model="valid">
					<v-row>
						<v-col cols="12">
							<v-text-field
								v-model="password"
								:append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
								:rules="[validRequired, validLength8chars]"
								:type="show1 ? 'text' : 'password'"
								name="input-10-1"
								:label="$t('common.fldPassword')"
								counter
								@click:append="show1 = !show1"
							></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field
								block
								v-model="verify"
								:append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
								:rules="[validRequired, passwordMatch]"
								:type="show1 ? 'text' : 'password'"
								name="input-10-1"
								:label="$t('common.fldPasswordConfirm')"
								counter
								@click:append="show1 = !show1"
							></v-text-field>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-btn x-large block :disabled="!valid" color="success" :loading="isLoading" @click="send()"> {{ $t("common.btnTitle") }}</v-btn>
			</v-card-actions>
		</v-card>


</template>

<script>
import { mapActions } from "vuex"

export default {
	name: "RestorePage",

	components: {},
	data: () => ({
		params: undefined,
		verify: "",
		show1: false,
		password: "",
		token: "",
		valid: false,
		//
	}),
	methods: {
		...mapActions(["apiBackendRestoreChange"]),


		validRequired(v) {
			return !!v || this.$t("common.required")
		},
		validLength8chars(v) {
			return v.length >= 8 || this.$t("common.passwordLength")
		},

		async send() {
			await this.apiBackendRestoreChange({password: this.password, token: this.token})
		},
	},
	computed: {
		passwordMatch() {
			return () => this.password === this.verify || this.$t("common.passwordMatch")
		},
	},
	created() {
		this.params = new URL(document.location).searchParams
		this.token = this.params.get("token")
		//console.log("token", this.params.get("token"))
	},
}
</script>
